import { useEffect, useState } from 'react';

import { isMac } from '@/hooks/platform';
import { Separator } from '@heidi/design-system/separator';
import { isComputerUseUnsupported } from '@heidi/plugin-rpa';

import { requestPermission } from '../api/permission-bridge';
import { useComputerUseReadiness } from '../hooks/useComputerUseReadiness';
import {
  computerUseStatuses,
  missingComputerUsePermissions,
} from '../lib/computer-use-statuses';
import { requiredPermissions } from '../matrix';
import { PermissionRowList } from './permission-row-list';

/**
 * Live Screen Recording and Accessibility rows for Settings > Desktop > Computer use.
 * Shows nothing once both are granted, on the Mac App Store build, and off macOS.
 */
export function ComputerUsePermissionStatus() {
  // With nothing to show, only coming back from System Settings re-reads
  const [nothingToShow, setNothingToShow] = useState(false);
  const readiness = useComputerUseReadiness(
    !isMac ? 'off' : nothingToShow ? 'on_focus' : 'live'
  );
  const statuses =
    readiness && !isComputerUseUnsupported(readiness)
      ? computerUseStatuses(readiness)
      : null;
  const missingCount = statuses ? missingComputerUsePermissions(statuses).length : 0;
  useEffect(() => {
    if (readiness) setNothingToShow(missingCount === 0);
  }, [readiness, missingCount]);
  if (!statuses || missingCount === 0) return null;

  return (
    <>
      <Separator />
      <PermissionRowList
        rows={requiredPermissions('computer_use')}
        statuses={statuses}
        onRequestPermission={(permission) => void requestPermission(permission)}
      />
    </>
  );
}
